import React, {useState, useEffect} from "react";
import ringIcon from "../../img/ringIcon.svg";
import redRingIcon from "../../img/redRingIcon.svg";
import rowBack from "../../img/rowBackIcon.svg";
import avatarUser from "../../img/userAvatarIcon.svg";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import {useNavigate} from "react-router-dom";
import {logout} from "../../utils/Logout/Logout";
import NotificationsModal from "../NotificationsModal/NotificationsModal";

const Header = (props) => {

    const {
        sidebarName,
        onHandleOpenProfileUser,
        activeProfileModal,
        setActiveProfileModal,
        getListNotifications,
    } = props;

    const { auth, nameDocHeader, setLoggedIn, changeToggleBackPage } = useAuth();
    const navigate = useNavigate();
    const [activeNotificationModal, setActiveNotificationModal] = useState(false);

    const onHandleNotificationModal = () => {
        if (getListNotifications.length > 0 && activeNotificationModal === false) {
            setActiveNotificationModal(true)
        } else {
            setActiveNotificationModal(false)
        }
    }

    return (
        <div className="header__container">
            <div className="header-title-block">
                <p className={nameDocHeader === '' ? "header-title-block__name-page" : "header-title-block__name-page hide"}>{sidebarName}</p>
                <div className={nameDocHeader === '' ? "header-title-block__row-back-last-page hide" : "header-title-block__row-back-last-page"}>
                    <img onClick={changeToggleBackPage} src={rowBack} alt={'иконка-стрелочка'} className="header-title-block__row-back"/>
                    <p className="header-title-block__name-document">{nameDocHeader}</p>
                </div>
            </div>
            <div className="header-profile">
                <div className="header-profile__icon-ring">
                    <img onClick={onHandleNotificationModal} src={activeNotificationModal === true ? redRingIcon : ringIcon} alt={'иконка-уведомление'} className="header-profile__icon-ring"/>
                    {activeNotificationModal && <NotificationsModal
                        getListNotifications={getListNotifications}
                    />}
                </div>
                <div className="header-profile__profile">
                    <img src={avatarUser} className="header-profile__avatar-icon" alt={'аватар'}/>
                    <div onClick={() => setActiveProfileModal(!activeProfileModal)} className="header-profile__name-role">
                        <p className="header-profile__name-user">{auth?.user?.lastName} {auth?.user?.firstName}</p>
                        <p className="header-profile__role-user">{auth?.roles[0]}</p>
                    </div>
                    <div className={activeProfileModal ? "header-profile__modal-profile-user-exit" : "header-profile__modal-profile-user-exit hide"}>
                        <p onClick={onHandleOpenProfileUser} className="header-profile__modal-profile-user-exit-item">MyProfile</p>
                        <p onClick={() => logout(setLoggedIn, navigate)} className="header-profile__modal-profile-user-exit-link">Logout</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Header;